/** Start page for an office role that can't see work orders (e.g. a custom Payroll role). */
import { Link } from 'react-router-dom';
import type { Me } from '@wo/shared';
import { Card, PageHeader } from '../components/ui';
import { can } from '../lib/perm';

export function HomePage({ me }: { me: Me }) {
  return (
    <>
      <PageHeader title={`Hello, ${me.name}`} />
      <Card>
        <ul className="space-y-2 text-sm">
          {me.tracksHours && <li>Use <b>Clock In</b> / <b>Clock Out</b> at the top of the page for your hours.</li>}
          {can(me, 'reports.view', 'timesheets.view') && (
            <li><Link className="font-semibold text-blue-800 hover:underline" to="/reports">Reports</Link>{can(me, 'timesheets.view') && ' — including the payroll timesheet'}</li>
          )}
          {!me.tracksHours && !can(me, 'reports.view', 'timesheets.view') && <li>Your role has no screens yet. Ask an Admin.</li>}
        </ul>
      </Card>
    </>
  );
}
